import React, { useEffect, useState } from "react";
import { CheckSVG } from "../svgs/checkSVG";
import { ArrowButton } from "../buttons/ArrowButton";
import { motion, useAnimation } from "framer-motion";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import {
  handleNext,
  handleBefore,
  setSelectedGame,
} from "../../actions/game.action";
import RippleButton from "../buttons/RippleButton";

const NavigateHeader = () => {
  const controls = useAnimation();
  const dispatch = useDispatch();
  const game = useSelector(({ game }) => game);
  const { gamesOfToday, selectedGame } = game;

  const { t } = useTranslation();

  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const handleClickOutside = () => {
      setVisible(false);
    };
    document.addEventListener("click", handleClickOutside);
    return () => document.removeEventListener("click", handleClickOutside);
  }, [setVisible]);

  useEffect(() => {
    if (visible)
      controls.start({
        height: Math.min(gamesOfToday?.length * 38, 340),
      });
    else controls.start({ height: 0 });
  }, [controls, visible]);

  return (
    <div className="my-3 flex w-full flex-row items-center justify-center">
      <ArrowButton
        className="size-10 items-center justify-center rounded-lg border fill-black p-1 active:bg-slate-200 disabled:bg-slate-200 dark:fill-slate-100 active:dark:bg-slate-500 disabled:dark:bg-slate-500  md:hover:bg-majky-200 md:hover:dark:bg-slate-500"
        isLeft={true}
        onClick={() => {
          dispatch(handleBefore());
        }}
      />
      <div className="relative mx-2 w-full max-w-72 px-2">
        <RippleButton
          className="text-md translate my-0.5 flex h-10 w-full items-center justify-center gap-2 rounded-lg bg-majky-600 p-1 font-semibold text-white hover:bg-majky-700 active:bg-majky-700"
          onClick={(e) => {
            setVisible(!visible);
            if (!visible) e.stopPropagation();
          }}
        >
          {selectedGame?.imgSrcs?.map((imgSrc, _idx) => (
            <img
              key={`imgSrcs-${_idx}`}
              className="mt-0.05 mr-1.5 inline-block h-4 w-4 align-middle"
              alt={selectedGame?.imgAlts[_idx]}
              src={imgSrc?.toLowerCase()}
            />
          ))}
          <span className="ml-2">{t(selectedGame?.label)}</span>
          <div
            className={`flex transform items-center transition-transform duration-500 ${
              visible ? "rotate-180" : "rotate-0"
            }`}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              fill="white"
              width="24px"
              height="24px"
            >
              <path d="M7.41 8.59L12 13.17l4.59-4.58L18 10l-6 6-6-6 1.41-1.41z"></path>
              <path d="M0 0h24v24H0V0z" fill="none"></path>
            </svg>
          </div>
        </RippleButton>
        <motion.div
          initial={{ height: 0 }}
          animate={controls}
          className={`absolute left-2 right-2 z-[99] my-1 overflow-hidden rounded-lg bg-white drop-shadow-lg dark:bg-slate-600`}
        >
          {gamesOfToday?.map((category, idx) => (
            <motion.div key={"nav-dropdown-" + idx} whileTap={{ scale: 0.8 }}>
              <div
                className="cursor-pointer px-2 py-2 text-sm transition-all duration-300 hover:bg-majky-400 hover:font-bold hover:dark:bg-majky-400"
                onClick={() => {
                  dispatch(setSelectedGame(category));
                  setTimeout(() => {
                    setVisible(false);
                  }, 300);
                }}
              >
                <div className="flex w-full flex-row items-center justify-start">
                  <span className="flex w-12 flex-row items-center justify-start">
                    {category?.imgSrcs?.map((imgSrc, _idx) => (
                      <img
                        key={`imgSrcs-${_idx}`}
                        className="mt-0.05 mr-1.5 inline-block h-4 w-4 align-middle"
                        alt={category.imgAlts[_idx]}
                        src={imgSrc?.toLowerCase()}
                      />
                    ))}
                  </span>
                  <span className="flex-1">{t(category.label)}</span>
                  {game[category.key].completed && (
                    <CheckSVG className="fill-majky-600" />
                  )}
                </div>
              </div>
              {idx < gamesOfToday.length - 1 && (
                <div className="mx-2 border-b border-slate-100 dark:border-slate-500" />
              )}
            </motion.div>
          ))}
        </motion.div>
      </div>
      <ArrowButton
        className="size-10 items-center justify-center rounded-lg border fill-black p-1 active:bg-slate-200 disabled:bg-slate-200 dark:fill-slate-100 active:dark:bg-slate-500 disabled:dark:bg-slate-500  md:hover:bg-majky-200 md:hover:dark:bg-slate-500"
        isLeft={false}
        onClick={() => {
          dispatch(handleNext());
        }}
      />
    </div>
  );
};

export default NavigateHeader;
